module.exports = __webpack_public_path__ + "static/media/about-video-gym-img.3ed47b87.jpg";